<template>
  <v-ons-navigator swipeable swipe-target-width="50px"
    :page-stack="pageStack"
    :pop-page="storePop"
    :options="options"
  ></v-ons-navigator>
</template>

<script>
import { EventBus } from './EventBus.js';
import AppSplitter from './AppSplitter.vue';
import Login from './pages/Login.vue';

export default {
  beforeCreate() {
    EventBus.$on('navigate', (component_name) => {
      this.$store.commit('splitter/close');

      if(component_name != 'AppSplitter') {
        var Component = require('./pages/' + component_name + '.vue');
      }
      else {
        var Component = require('./' + component_name + '.vue');
      }
      this.$store.commit('navigator/push', Component);
    });

    EventBus.$on('back', () => {
      this.$store.commit('navigator/pop');
    });

    if(!loggedIn) {
      EventBus.$emit('navigate', 'Login');
    }
    else {
      EventBus.$emit('navigate', 'AppSplitter');
    }
  },
  computed: {
    pageStack() {
      return this.$store.state.navigator.stack;
    },
    options() {
      return this.$store.state.navigator.options;
    },
    borderRadius() {
      return new URL(window.location).searchParams.get('borderradius') !== null;
    }
  },
  methods: {
    storePop() {
      this.$store.commit('navigator/pop');
    },
  }
};
</script>



// WEBPACK FOOTER //
// AppNavigator.vue?70b3e514